import { ref } from 'vue';
import { useThrottledResize } from './useThrottledResize';

export function useMobile() {
  const isMobile = ref(false);

  const checkMobile = () => {
    const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const isNarrow = window.innerWidth < 768;
    isMobile.value = hasTouch && isNarrow;
  };

  // Check initially
  checkMobile();

  // Use throttled resize listener (150ms delay)
  useThrottledResize(checkMobile, 150);

  return { isMobile };
}
